(function($){

    
   // Menu animations
    $('#trigger').on('click', function(){

        if($(this).hasClass('open')){

            $(this).removeClass('open');
            $('body').removeClass('disable');
            $('#mainMenu').removeClass('nav-open');

        } else {

            $('body').addClass('disable');
            $(this).addClass('open');
           
            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });
            $('#mainMenu').addClass('nav-open');

        }

    });

    $('#mainMenu a').on('click', function(){

    	if($('#trigger').hasClass('open')){

	       
            $('body').removeClass('disable');
            $('#mainMenu').removeClass('nav-open');
            $('#trigger').removeClass('open');

	    }

    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });


    // Initiate aos animations
	AOS.init();

    // Remove empty paragraphs
    $('p:empty:not([role])').remove();
    
    
    document.querySelectorAll('.dropdown-toggle').forEach(function (dropdownToggle) {
      dropdownToggle.addEventListener('click', function (e) {
        // Check if the dropdown is already open
        if (this.getAttribute('aria-expanded') === 'true') {
          // If the parent link is clicked while open, navigate to the link
          window.location.href = this.getAttribute('href');
        }
      });
    });

})(jQuery);